const alerts = (extra = false) => ({
  	AFFECTATIONS_OPS_CATEGS_CONFLICT: extra
    ? 
		<>
			<p className="font-semibold">Veuillez confirmer la modification de la catégorie d’association ci dessous par la nouvelle catégorie sélectionnée.</p>
			<div dangerouslySetInnerHTML={{ __html: extra }} />
		</>
    : 
		"Veuillez confirmer la modification de la catégorie d’association ci dessous par la nouvelle catégorie sélectionnée.",

  	AFFECTATIONS_INVOICES_CATEGS_CONFLICT: extra
    ?
		<>
			<p className="font-semibold">Veuillez confirmer la modification de la catégorie d’association ci dessous par la nouvelle catégorie sélectionnée.</p>
			<div dangerouslySetInnerHTML={{ __html: extra }} />
		</>
    : 
		"Veuillez confirmer la modification de la catégorie d’association ci dessous par la nouvelle catégorie sélectionnée.",

	ASSOCIATIONS_OPS_DOCS_CONFLICT: extra
	?
		<>
			<p className="font-semibold">Le document et l’opération bancaire à associer ne sont pas de même catégorie. Choisissez la catégorie à appliquer à l’association :</p>
			<div dangerouslySetInnerHTML={{ __html: extra }} />
		</>
	:
		null
});

export {
  alerts
}
